import { NormalizedCacheObject, ApolloClient } from '@apollo/client'

import { IgnoreSubscriptionsLink } from './IgnoreSubscriptionsLink'
import { MutationsTracker } from './MutationsTracker'
import { getShouldTrackMutationPredicates } from './shouldTrackMutationPredicates'
import {
  getIsMutationSuccessfulPredicates,
  getSubscriptionsToMutationsMap,
} from './subscriptionsMutationsMap'

export const createIgnoreSubscriptionsLink = (
  getClient: () => ApolloClient<NormalizedCacheObject>
) =>
  new IgnoreSubscriptionsLink({
    tracker: new MutationsTracker(),
    isMutationSuccessful: getIsMutationSuccessfulPredicates,
    shouldTrackMutation: getShouldTrackMutationPredicates,
    subscriptionsToMutationsMap: getSubscriptionsToMutationsMap(getClient),
  })
